<template>
  <div>
    <div class="module" id="DestinationDocument" style="padding-bottom: 20px;">
      <div class="module-label">
        {{moduleData.itemName}}
      </div>
      <el-form :class="{ 'cs-form': isCs }" :model="form" :rules="rules" ref="form" label-width="165px" label-position="right" v-if="formConfig.length">
        <el-row style="padding-right: 46px;">
          <el-col :span="8">
            <el-form-item label="选择目的国" class="is-required" prop="destinationCountry">
              <el-select v-model="form.destinationCountry" placeholder="请选择" @change="countryChange" :disabled="disabledAll || (!isCreate && formInfo.orderBase.state !== 11)" style="width: 100%;">
                <el-option v-for="item in formConfigByCode.destinationCountry.enums" :key="item.enumCode" :label="item.enumName" :value="item.enumCode">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="跟踪单号" class="is-required" prop="trackingNo" v-if="form.ladingBillType === 'billOfLading'">
              <el-input v-model="form.trackingNo" :disabled="!isCs" maxlength="200"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24" class="country-tips">
            提醒：如果您的货物只是在第三国中转，请申请最终目的国的电子跟踪单。
          </el-col>
          <el-col :span="24" class="file-types">
            <template v-for="(item, index) in formConfigByCode.ladingBillType.enums">
              <div class="file-type" :key="index" @click="form.ladingBillType = item.enumCode" v-if="!disabledAll || form.ladingBillType === item.enumCode">
                {{item.remark}}
                <div class="radio-content">
                  <el-radio v-model="form.ladingBillType" :label="item.enumCode" >{{item.enumName}}</el-radio>
                </div>
              </div>
            </template>
          </el-col>
          <el-col :span="24" class="file-type-tips" v-if="fileTypes.length">
            请上传申报所需文件，上传后必填信息可跳过
          </el-col>
          <template v-for="item in fileTypes">
            <el-col :span="24" :key="item.attrCode" class="file-col" v-if="item.type === 2 || item.attrCode === form.ladingBillType">
              <el-form-item>
                <template #label>
                  <div v-html="item.attrName"></div>
                </template>
                <div style="display: flex; align-items: center;">
                  <UploadFile :api-url="host.javaUrl" v-model="form[item.attrCode]" v-if="!disabledAll" :limit="item.fillLen">
                    <template #btn="scope">
                      <el-button class="common-btn" :disabled="disabledAll || form[item.attrCode].length >= item.fillLen" :loading="scope.loading" style="margin-right: 50px;">
                        上传文件
                      </el-button>
                    </template>
                  </UploadFile>
                  <div class="file-list">
                    <div class="file-item" v-for="(file, fileIndex) in form[item.attrCode]" :key="item.attrCode + fileIndex">
                      <a :href="file.src" class="file-name" target="_blank">{{file.name}}</a>
                      <span class="del-btn" @click="delFile(form[item.attrCode], fileIndex)" v-if="!disabledAll">删除</span>
                    </div>
                  </div>
                </div>
              </el-form-item>
            </el-col>
          </template>

        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
import {applyMixins} from "src/components/application/components/mixin";
import UploadFile from "src/components/UploadFile/index.vue";
import {emailReg} from "utils";

export default {
  name: "DestinationDocument",
  mixins: [applyMixins],
  components: { UploadFile },
  data() {
    return {
      form: {
        ladingBillType: 'draftOfBL',
        destinationCountry: '',
        trackingNo: '',
        draftOfBL: [],
        billOfLading: [],
        commercialInvoice: [],
        packingList: []
      },
      countryList: [],
      fileTypes: [],
      formConfigByCode: {},
      configArr: []
    }
  },
  computed: {
    rules() {
      return {
        destinationCountry: [this.required],
        // 正则校验
        trackingNo: [{pattern: /^[^\u4e00-\u9fa5]+$/, message: '请输入数字和英文字符、标点'}]
      }
    },
  },
  watch: {
    formConfig: {
      handler(val) {
        if (!val.length) return
        const configObj = val.find(v => v.areaCode === 'destinationList') || {}
        const configArr = configObj.attrs || []
        this.formConfigByCode = this.getFormConfigByCode(configArr)
        configArr.filter(v => {
          if (v.attrCode === 'ladingBillType') {
            this.form[v.attrCode] = 'draftOfBL'
            return
          }
          this.form[v.attrCode] = ''
        })
        this.configArr = JSON.parse(JSON.stringify(configArr))
        if (this.formInfo.destinationList && this.formInfo.destinationList.length) {
          this.formInfo.destinationList.forEach(v => {
            this.form[v.attrCode] = v.attrText || v.attrValue
            this.form[v.attrCode + 'Name'] = v.attrName
          })
          this.$emit('update:originalCountry', this.form.destinationCountry)
        }
        if (this.form.destinationCountry) {
          this.countryChange(this.form.destinationCountry)
        }
        this.form.trackingNo = this.formInfo.application.applicationNo
        if (this.isAgain) this.form.trackingNo = ''
      },
      immediate: true
    },
    formInfo: {
      handler(val) {
      },
      immediate: true
    },
  },
  methods: {
    countryChange(countryCode) {
      console.log(countryCode);
      const configObj = this.formConfig.find(v => v.areaCode === 'destinationList_' + countryCode) || {}
      const configArr = configObj.attrs || []
      this.fileTypes = configArr.filter(v => {
        if (v.type === 2 || v.type === 3) {
          if (!this.form[v.attrCode]) this.$set(this.form, v.attrCode, [])
          return true
        }
        this.form[v.attrCode] = ''
      })
    },
    getValidate() {
      this.configArr.forEach(v => {
        v.attrValue = ''
        if (v.type === 2 || v.type === 3) {
          v.attrText = this.form[v.attrCode]
        } else {
          v.attrValue = this.form[v.attrCode]
        }
      })
      const fileTypes = this.fileTypes.map(v => {
        v.attrValue = ''
        if (v.type === 2 || v.type === 3) {
          v.attrText = this.form[v.attrCode]
        } else {
          v.attrValue = this.form[v.attrCode]
        }
        const data = JSON.parse(JSON.stringify(v))
        data.areaCode = 'destinationList'
        return data
      })
      const data = {
        destinationList: this.configArr.concat(fileTypes),
        destinationObj: this.form,
        application: {
          applicationNo: this.form.trackingNo
        }
      }
      this.$emit('input', JSON.parse(JSON.stringify(data)))
      return new Promise(resolve => this.$refs.form.validate(resolve))
    },
    delFile(item, index) {
      console.log(item, index);
      item.splice(index, 1)
    }
  }
}
</script>

<style scoped lang="scss">
.country-tips {
  padding-left: 165px;
  color: rgb(255, 60, 60);
  font-size: 12px;
  line-height: 16px;
  margin-bottom: 24px;
  position: relative;
  top: -8px;
}
.file-types {
  display: flex;
  margin-bottom: 23px;
  padding-left: 165px;
  .file-type {
    width: 210px;
    height: 90px;
    margin-right: 30px;
    padding: 17px 19px;
    color: rgb(51, 51, 51);
    font-size: 14px;
    line-height: 14px;
    border: 1px solid rgb(202, 67, 0);
    border-radius: 4px;
    cursor: pointer;
  }
  .radio-content {
    display: flex;
    align-items: center;
    margin-top: 16px;
    ::v-deep .el-radio__label {
      color: #333;
      font-weight: 700;
    }
  }
}
.file-type-tips {
  color: rgb(51, 51, 51);
  font-size: 14px;
  line-height: 18px;
  margin-bottom: 28px;
  padding-left: 165px;
}
::v-deep .el-form-item {
  display: flex;
  align-items: center;
}
::v-deep .el-form-item__label {
  line-height: 18px;
  flex-shrink: 0;
}
::v-deep .el-form-item__content {
  margin-left: 0!important;
}
#DestinationDocument .file-list {
  color: rgb(33, 63, 165);
  font-size: 14px;
  line-height: 30px;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 0;
  .file-item {
    margin-right: 50px;
  }
  .file-name {
    cursor: pointer;
    color: rgb(33, 63, 165);
    text-decoration: none;
  }
  .del-btn {
    cursor: pointer;
    color: #999999;
    margin-left: 15px;
    &:hover {
      color: rgb(33, 63, 165);
    }
  }
}
.file-col:not(:last-child) {
  border-bottom: 1px dashed rgb(229, 229, 229);
  margin-bottom: 22px;
}
</style>